import { ApiClient, ApiClientPdf } from "../../utils/api-client";
import { transformDateToUniversalString } from "../../utils/dateUtils";


export const getInvoices = async (page, pageSize, billNumber, issueDateFrom, issueDateTo, orderBy, orderDirection) => {
  try {
    const response = await ApiClient.get(`/bills`, {
      params: {
        page: page,
        pageSize: pageSize,
        billNumber: billNumber,
        issueDateFrom: issueDateFrom ? transformDateToUniversalString(issueDateFrom) : null,
        issueDateTo: issueDateTo ? transformDateToUniversalString(issueDateTo) : null,
        orderBy: orderBy,
        orderDirection: orderDirection
      }
    });

    return response.data;
  } catch (e) {
    return await {
      "isGrade": true,
      "debtor": null
    }
  }
}

export const getPrintBill = async billId => {
  try {
    const response = await ApiClientPdf.get(`/bill/${billId}/pdf`);
    return response.data;
  } catch (e) {
    return await {}
  }
}


